import React from 'react';
import classnames from 'classnames';
import NoteNumber from '../../NoteNumber';
import {useCompleteInspectionContext} from '../../CompleteInspectionContext';
import {getSelectedOptionLabel} from '../../../utils/options';
import {getBuildingBuildTypeValue} from '../../../utils/texts';
import styles from './styles.module.scss';

export const TextItem4 = React.forwardRef(({className}, ref) => {
  const context = useCompleteInspectionContext();

  return (
    <div ref={ref}>
      {Boolean(context.data.pdfData.buildingEntranceCount) && (
        <div
          className={classnames(styles.itemText, styles.innerPadding, className)}
        >
          <span className={styles.bold}>מספר כניסות: </span>
          {` ${context.data.pdfData.buildingEntranceCount}.`}
        </div>
      )}
    </div>
  );
});

export const TextItem5 = React.forwardRef(({className}, ref) => {
  const context = useCompleteInspectionContext();
  const currentBuildingOnPillars = getSelectedOptionLabel(context.data.pdfData.buildingOnPillars, context.options.buildingOnPillarsOptions);
  const buildingOnPillarsValue = ` מעל קומת ${currentBuildingOnPillars}`;

  return (
    <div className={classnames(styles.itemText, styles.innerPadding, className)}
         ref={ref}>
      <span className={styles.bold}>מס' קומות: </span>
      {context.data.pdfData.buildingFloorsCount} קומות
      <span>{context.data.pdfData.buildingOnPillars !== 2 && buildingOnPillarsValue}</span>
      <span>.</span>
    </div>
  );
});

export const TextItem6 = React.forwardRef(({className}, ref) => {
  const context = useCompleteInspectionContext();

  return (
    <div ref={ref}>
      {Boolean(context.data.pdfData.buildingApartmentPerFloor) && (
        <div
          className={classnames(styles.itemText, styles.innerPadding, className)}
        >
          <span className={styles.bold}>מספר דירות בקומה: </span>
          {` ${context.data.pdfData.buildingApartmentPerFloor}.`}
        </div>
      )}
    </div>
  );
});

export const TextItem7 = React.forwardRef(({className}, ref) => {
  const context = useCompleteInspectionContext();

  return (
    <div ref={ref}>
      {Boolean(context.data.pdfData.buildingTenantsRegisteredCount) && (
        <div
          className={classnames(styles.itemText, styles.innerPadding, className)}
        >
          <span className={styles.bold}>מס' דיירים ברישום: </span>
          {` ${context.data.pdfData.buildingTenantsRegisteredCount}.`}
        </div>
      )}
    </div>
  );
});

export const TextItem8 = React.forwardRef(({className}, ref) => {
  const context = useCompleteInspectionContext();

  return (
    <div ref={ref}>
      {Boolean(context.data.pdfData.buildingTenantsLicenseCount) && (
        <div
          className={classnames(styles.itemText, styles.innerPadding, className)}
        >
          <span className={styles.bold}>מס' דיירים ברישוי: </span>
          {` ${context.data.pdfData.buildingTenantsLicenseCount}.`}
        </div>
      )}
    </div>
  )
});

export const TextItem9 = React.forwardRef(({className}, ref) => {
  const context = useCompleteInspectionContext();
  const buildingElevatorValue = getSelectedOptionLabel(context.data.pdfData.buildingElevator, context.options.buildingElevatorOptions);
  const buildingElevatorValueOrDefault = context.data.pdfData.buildingElevator > 0
    ? buildingElevatorValue
    : 'ללא';

  return (
    <div className={classnames(styles.itemText, styles.innerPadding, className)}
         ref={ref}>
        <span
          className={styles.bold}>מעלית: </span>
      {` ${buildingElevatorValueOrDefault}.`}
    </div>
  );
});

export const TextItem10 = React.forwardRef(({className}, ref) => {
  const context = useCompleteInspectionContext();
  const buildingParkingValue = getSelectedOptionLabel(context.data.pdfData.buildingParking, context.options.buildingParkingOptions);

  return (
    <div className={classnames(styles.itemText, styles.innerPadding, className)}
         ref={ref}>
      <span className={styles.bold}>חניה: </span>
      <span>{` ${buildingParkingValue}.`}</span>
    </div>
  );
});

export const TextItem11 = React.forwardRef(({className}, ref) => {
  const context = useCompleteInspectionContext();
  const buildingIntercomValue = getSelectedOptionLabel(context.data.pdfData.buildingIntercom, context.options.buildingIntercomOptions);

  return (
    <div ref={ref}>
      {Boolean(context.data.pdfData.buildingIntercom) && (
        <div className={classnames(styles.itemText, styles.innerPadding, className)}>
          <span className={styles.bold}>אינטרקום: </span>
          <span>{` ${buildingIntercomValue}.`}</span>
        </div>
      )}
    </div>
  );
});

export const TextItem12 = React.forwardRef(({className}, ref) => {
  const context = useCompleteInspectionContext();
  const buildingMaintenanceValue = getSelectedOptionLabel(context.data.pdfData.buildingMaintenance, context.options.buildingMaintenanceOptions);

  return (
    <div className={classnames(styles.itemText, styles.innerPadding, className)}
         ref={ref}>
      <span className={styles.bold}>מצב תחזוקה: </span>
      <span>{` ${buildingMaintenanceValue}.`}</span>
    </div>
  );
});

export const TextItem13 = React.forwardRef(({className}, ref) => {
  const context = useCompleteInspectionContext();
  const buildingPhysicalStateValue = getSelectedOptionLabel(context.data.pdfData.buildingPhysicalState, context.options.buildingPhysicalStateOptions);
  const {noteNumbers} = context;

  return (
    <div className={classnames(styles.itemText, styles.innerPadding, className)}
         ref={ref}>
      <span className={styles.bold}>
          מצב פיזי
          <NoteNumber
            id={'buildingPhysicalStateValue'}>{noteNumbers.buildingPhysicalStateValue}</NoteNumber> :
        </span>
      <span
        data-testid="buildingPhysicalStateValue">
          {` ${buildingPhysicalStateValue}.`}
        </span>
    </div>
  );
});

export const TextItem14 = React.forwardRef(({className}, ref) => {
  const context = useCompleteInspectionContext();

  return (
    <div ref={ref}>
      {Boolean(context.data.pdfData.buildingBuildType) && (
        <div
          className={classnames(styles.itemText, styles.innerPadding, className)}
        >
          <span className={styles.bold}>סוג בנייה: </span>
          {` ${getBuildingBuildTypeValue(context.data.pdfData.buildingBuildType, context.data.pdfData.buildingBuildTypeText)}.`}
        </div>
      )}
    </div>
  )
});

export default [
  TextItem4,
  TextItem5,
  TextItem6,
  TextItem7,
  TextItem8,
  TextItem9,
  TextItem10,
  TextItem11,
  TextItem12,
  TextItem13,
  TextItem14,
];

